import draw from './canvas';
import { calcLayout } from './layout';
function getCvsElement() {
    let dom = document.querySelector('#canvas_20210121__');
    if (!dom) {
        dom = document.createElement('canvas');
        dom.setAttribute('type', '2d');
        dom.style.cssText = `
            position:absolute;
            left:-100000px;
            top:-100000px;
            z-index:-1;
            display:none;
        `;
        dom.id = 'canvas_20210121__';
        document.body.appendChild(dom);
    }
    return dom;
}
let cover, img;
function showCover(src) {
    if (!cover) {
        cover = document.createElement('div');
        cover.style.cssText = `
            position:absolute;
            top:0;
            bottom:0;
            left:0;
            right:0;
            display:flex;
            justify-content:center;
            align-items:center;
            overflow-y:auto;
            background: rgba(0,0,0,.3);
            z-index:100000;
        `;
        img = document.createElement('img');
        cover.appendChild(img);
        cover.addEventListener('click', function (e) {
            cover.remove();
        });
    }
    if (!cover.parentElement) {
        document.body.appendChild(cover);
    }
    img.src = src;
}
function getPoster(obj) {
    let cvs = getCvsElement(), ctx = cvs.getContext('2d');
    let calcPro = calcLayout(obj, ctx);
    const cache = new Map();
    async function getJpg(quality = 1) {
        if (!cache.get(quality)) {
            let layout = await calcPro;
            draw(ctx, layout);
            cache.set(quality, cvs.toDataURL('image/jpeg', quality));
        }
        return cache.get(quality);
    }
    async function getPng() {
        if (!cache.get('png')) {
            let layout = await calcPro;
            draw(ctx, layout);
            cache.set('png', cvs.toDataURL('image/png'));
        }
        return cache.get('png');
    }
    function test() {
        getJpg().then(dataUrl => {
            showCover(dataUrl);
        });
    }
    return {
        getJpg, getPng, test
    };
}
export default getPoster;
